import { render, staticRenderFns } from "./SalesDeliveryModal.vue?vue&type=template&id=885818fe"
import script from "./SalesDeliveryModal.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports